
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const CourierShipmentLegs = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
         props.onClickShowCourierShipmentLegs(props);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
 { props.hasUpload !==1 ? (
                <button onClick={handleRouteClick} className="custom-btn label label-success" title="View Invoices">
                    <i className="icofont icofont-site-map f20"></i> 
                </button>
            ): (<button onClick={handleRouteClick}  style={{border:"none", backgroundColor:"transparent",
                pointerEvents: props.disabled ? "none" : "auto", 
                opacity: props.disabled ? 0.5 : 1, }}className="custom-btn label label-success" title="Upload POD Inside">
<button className="icon-square" style={{color:"green"}}>
    <i className="icofont icofont-arrow-right" style={{color:"green"}}></i>
</button>        </button>)}       
        </div>
    );
};

export default CourierShipmentLegs;
